export enum ClientStorageItem {
  coupleName = "coupleName",
  CurrentPage = "currentPage",
  AccessToken = "accessToken",
  XAccountHash = "xAccountHash",
  PlannerWeddingAccountID = "plannerWeddingAccountID",
  WeddingVersion = "weddingVersion",
  ShowOnboarding = "showOnboarding",
  HasSeenWelcome = "hasSeenWelcome",
  UserWeddingRole = "userWeddingRole",
  HasSeenDashboard = "hasSeenDashboard",
  ChakraUIColorMode = "chakra-ui-color-mode",
  HasCompletedDashboardSetup = "hasCompletedDashboardSetup",
}

export const ClientStorage = {
  store(item: ClientStorageItem, value: string) {
    localStorage.setItem(item, value);
  },
  fetch<T extends string>(item: ClientStorageItem) {
    return localStorage.getItem(item) as T;
  },
  delete(item: ClientStorageItem) {
    return localStorage.removeItem(item);
  },
};

export const clearWeddingSessionContext = () => {
  ClientStorage.delete(ClientStorageItem.AccessToken);
  ClientStorage.delete(ClientStorageItem.UserWeddingRole);
  ClientStorage.delete(ClientStorageItem.XAccountHash);
  ClientStorage.delete(ClientStorageItem.PlannerWeddingAccountID);
  ClientStorage.delete(ClientStorageItem.WeddingVersion);
};
